import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import config from '../../config';
import { AuthenticationContext } from '../../authentications/contexts/AuthenticationContext';

const CreateView = (props) => {
  const {
    title,
    serverPath,
    clientPath,
    component,
    FormComponent,
  } = props;

  const [serverErrors, setServerErrors] = React.useState(null);

  const { currentUser } = React.useContext(AuthenticationContext);

  const { t } = useTranslation();

  const navigate = useNavigate();

  const fullPath = React.useMemo(() => `v2/component_types/${serverPath}`, [serverPath]);

  const formObject = useForm();

  const handleSubmit = async (data) => {
    setServerErrors(null);
    try {
      const result = await axios.post(`${config.baseApiUrl}${fullPath}`, {
        [component]: data,
      }, {
        headers: {
          Authorization: `Bearer ${currentUser.accessToken}`,
        },
      });
      navigate(`/componentTypes/${clientPath}/${result.data.id}`);
    }
    catch (e) {
      if (e.isAxiosError && e.response.status === 409) {
        setServerErrors(e.response.data.errors);
      }
      else {
        setServerErrors([t('commons.genericError')]);
      }
    }
  };

  return (
    <>
      <h1>{title}</h1>
      <FormComponent
        onSubmit={handleSubmit}
        serverErrors={serverErrors}
        formObject={formObject}
        buttonText={t('commons.actions.create')}
      />
    </>
  );
};

export default CreateView;

const propTypes = {
  serverPath: PropTypes.string.isRequired,
  clientPath: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  FormComponent: PropTypes.any.isRequired,
};

CreateView.propTypes = propTypes;
